// dependencies
import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
// components
import SingleSection from './SingleSection'

const StrapiSectionsBanner = ({
  data,
  hasMainBannerImage = {},
  bannerHeight,
  isFullWidth,
  isMosaicGridTile = false,
  bannerLink,
}) => {
  const sections = data || []
  return (
    <>
      {sections.map(({ BannerSection }) =>
        BannerSection ? (
          <SingleSection
            BannerSection={BannerSection}
            key={BannerSection.id}
            hasMainBannerImage={hasMainBannerImage}
            bannerHeight={bannerHeight}
            isFullWidth={isFullWidth}
            isMosaicGridTile={isMosaicGridTile}
            bannerLink={bannerLink}
          />
        ) : null,
      )}
    </>
  )
}

StrapiSectionsBanner.propTypes = {
  data: PropTypes.array.isRequired,
  hasMainBannerImage: PropTypes.object,
  bannerHeight: PropTypes.number,
  isFullWidth: PropTypes.bool,
  isMosaicGridTile: PropTypes.bool,
  bannerLink: PropTypes.string,
}

export default StrapiSectionsBanner
